'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.demand_control_edit', {
    url: '/company/:company_id/demand_control_edit/:id',
    template: '<oem-demand-control-edit></oem-demand-control-edit>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/demand_control/edit/demand_control_edit.routes.js